/* Enhanced collection template: scroll reveal. Content stays visible without JS (the hidden state is
   only applied once .ecp-js is on <html>). Also re-runs inside the theme editor. */
(function () {
  var root = document.documentElement;
  root.classList.add('ecp-js');
  var io = null;
  function show(el) { el.classList.add('in'); }
  function observe() {
    var els = document.querySelectorAll('.ecp-reveal:not(.in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(show); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { show(en.target); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    els.forEach(function (el) { io.observe(el); });
  }
  /* The theme header is position:fixed and its page offset differs per template/breakpoint, so measure how
     much of the first section it covers and add that as top padding (--ecp-offset). */
  function offset() {
    var header = document.querySelector('.header_main');
    var first = document.querySelector('.ecp');
    if (!header || !first || header.classList.contains('is-compact')) return;
    var top = first.getBoundingClientRect().top + (window.pageYOffset || 0);
    root.style.setProperty('--ecp-offset', Math.max(0, header.offsetHeight - top) + 'px');
  }
  function init() { observe(); offset(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', offset);
  window.addEventListener('resize', offset);
  document.addEventListener('shopify:section:load', init);
})();
